import type { ProductTourDef } from '@core/models/product-tour.model';

/** The real-estate tour definitions, imported only when a tour starts. */
export function loadRealEstateTours(): Promise<readonly ProductTourDef[]> {
  return import('@features/real-estate/constants/real-estate-tour-registry.constants').then(
    m => m.REAL_ESTATE_TOUR_REGISTRY
  );
}
